<template>
  <div>
    <public-title>已报价列表</public-title>
    <div class="bg-white load-area">
        <!--表格-->
        <div v-if="list.length>0&&!loading">
            <ReportList :list="list" :quoted="true"></ReportList>  
            <!--分页-->
            <div class="el-pagination">
            <el-pagination background layout="total,prev, pager, next" 
                :page-size="10"
                :total="total" :current-page="Number(formData.page)"
                @current-change="$GFUN.pageChange"/>
            </div>
        </div>
        <!--暂无信息-->
        <div class="no-data" v-if="list.length==0&&!loading">
            <NoPrompt></NoPrompt>
        </div>
        <div v-if="loading">
            <Spinner :quotation="1"></Spinner>
        </div>
    </div>
  </div>
</template>

<script>
 import ReportList from '../Components/ReportList.vue'                         //订单列表组件
 import  Spinner from '../Components/Spinner'                                  //骨架屏组件
 import  NoPrompt from '../Components/NoPrompt.vue'                            //暂无信息组件
 import { mapGetters,mapActions,mapState} from 'vuex'
 import { debounce } from "lodash";
    export default {
    name: 'InquiryList',
    components: {
        ReportList,
        Spinner,
        NoPrompt,
    },
    props: {},
    data() {
        return {
            formData:{
                page:1,
                status:1,
                num:10,
            },
            list: [],
            total: 0,
            loading: true,
        };
    },
    computed: {
        ...mapState(['newMessageInform']),
        ...mapGetters(['storeInfo', 'userInfo', 'isAdmin', 'isGroup']),
    },
    watch: {
        newMessageInform(newVal) {
            //收到通知刷新当前页面
            if (newVal && this.$GFUN.isInArray([30],newVal.type)){
                this.getOrderList();
            }
        },
        '$route.query':{
            handler(toVal,fromVal){
                this.formData.page=toVal.page||1
                this.getOrderList();
            },
            immediate:true
        }
    },
    created() {},
    mounted() {},
    methods: {
        ...mapActions(['POST_OrderHotelList']),
        getOrderList: debounce(function() {
            let data=this.formData;
            this.loading = true
            this.POST_OrderHotelList({data,successFun:(res)=>{
                this.loading = false
                this.total = res.count;
                this.list = res.list;

            }});
        },300),
    },
    };
</script>

<style lang="scss" scoped>
    .load-area{
        background-color:inherit !important;
        padding:0 !important;
        min-width: 1200px;
    }
    .text-psis{
        background-color: #f5f6f9;
        color: #6e7789;
        padding: 6px 8px;
        border-radius: 4px;
        font-size: 12px;
    }
    .el-pagination{
        background-color: #fff;
        margin-top:14px;
        padding-bottom:10px;
    }

</style>